// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-input[data-v-45f4a346]  input{height:2rem}.actions-block[data-v-45f4a346]{display:-webkit-box;display:-ms-flexbox;display:flex;grid-column-gap:1rem;-webkit-column-gap:1rem;-moz-column-gap:1rem;column-gap:1rem;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-right:2rem;width:6.2rem;overflow:hidden;-webkit-transition:all .2s;transition:all .2s}.slide-enter[data-v-45f4a346],.slide-leave-to[data-v-45f4a346]{width:0;padding:0}", ""]);
// Exports
module.exports = exports;
